/**
 * @param {object} toList
 * @param {object} items
 * @param {string|null|undefined} [parent]
 */
export const appendItems = (toList, items, parent = null) => {
    const target = parent ? toList.value[parent] : toList.value;
    target.items = target.items.concat(items.items);
    target.page = items.page;
    target.total = items.total;
    target.pages = items.pages;
    target.size = items.size;
};
